import React from "react"
import { Flex } from "antd"
import { useTranslation } from "react-i18next"
import { Text } from "ui/Typography"
import { AVAILABILITY_STATUSES, LEGEND_STATUSES } from "../constants"
import styles from "./AvailabilityLegend.module.css"

const SWATCH_CLASS = {
  [AVAILABILITY_STATUSES.AVAILABLE]: styles.available,
  [AVAILABILITY_STATUSES.LIMITED]: styles.limited,
  [AVAILABILITY_STATUSES.FULLY_BOOKED]: styles.fullyBooked,
  [AVAILABILITY_STATUSES.NOT_AVAILABLE]: styles.notAvailable
}

/** The four day-state colours, named. Sits beside the month stepper. */
const AvailabilityLegend = () => {
  const { t } = useTranslation()

  return (
    <Flex align="center" gap="var(--spacing-s)" wrap className={styles.legend}>
      <Text variant="caption" size="lg" className={styles.title}>
        {t("availability.legend", { defaultValue: "Legend:" })}
      </Text>
      {LEGEND_STATUSES.map(({ status, labelKey, labelDefault }) => (
        <Flex key={status} align="center" gap="var(--spacing-xxs)">
          <span className={`${styles.swatch} ${SWATCH_CLASS[status]}`} />
          <Text variant="caption" size="lg" className={styles.label}>
            {t(labelKey, { defaultValue: labelDefault })}
          </Text>
        </Flex>
      ))}
    </Flex>
  )
}

export default AvailabilityLegend
